let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9JzJ0")).then(() => parcelRequire('a8O92'));